// extracted by mini-css-extract-plugin
export var svgDefs = "SVGDefs_svgDefs__U4-8y";